import React from "react";
import styles from "./index.module.css";
import linkDrag from "../../../../../assets/linkItemDraggable.png";
import menuIcon from "../../../../../assets/icons/ellipsisMenu.png";
import deleteSectionIcon from "../../../../../assets/icons/mobileIcons/deleteOutlinedBlack.png";
import shareIcon from "../../../../../assets/icons/mobileIcons/share.png";
import { useDispatch } from "react-redux";
import { setDeletingLink } from "../../../../../redux/slice/dashboardSlice";
import { getBrandLogo } from "../../../utils";
import {
    setIsNotShortLink,
    updateShareModalDescripition,
    updateShareModalImage,
    updateShareModalOpen,
    updateShareShortLink
} from "../../../../../redux/slice/wallSlice";

const index = ({ link, showDivider, isMenuOpened, setIsMenuOpened, brandsIcons, closeMenu }) => {
    const prices = link.metaData.response.price;

    let productImg = link.metaData.response.images[0];
    if (!productImg.includes("https:")) {
        productImg = "https:" + productImg;
    }
    const dispatch = useDispatch();

    const iconSrc = getBrandLogo(brandsIcons, link?.metaData?.domain);

    const onDelete = async (e) => {
        e.stopPropagation();
        dispatch(setDeletingLink(link));
        closeMenu();
    };

    const onShareAafLink = (event) => {
        try {
            event.stopPropagation();
            dispatch(updateShareModalOpen());
            dispatch(updateShareModalDescripition(link?.metaData?.response?.product_title));
            dispatch(updateShareModalImage(productImg || ""));
            dispatch(updateShareShortLink(link?.metaData?.response?.short_link));
        } catch (error) {
            console.error("Error handling share icon click:", error);
        }
        closeMenu();
    };
    const onShare = (event) => {
        try {
            event.stopPropagation();
            dispatch(updateShareModalOpen());
            dispatch(setIsNotShortLink(true));
            dispatch(updateShareModalDescripition(link?.metaData?.response?.product_title));
            dispatch(updateShareModalImage(productImg || ""));
            dispatch(updateShareShortLink(link?.metaData?.response?.affiliate_link));
        } catch (error) {
            console.error("Error handling share icon click:", error);
        }
        closeMenu();
    };
    return (
        <>
            <div className={styles.productContainer}>
                <img className={styles.sortHandleImg} src={linkDrag} />
                <div className={styles.productDetails}>
                    <div className={styles.productImageContainer}>
                        <img className={styles.productImage} src={productImg} />
                        <img className={styles.brandImage} src={iconSrc} />
                    </div>
                    <div className={styles.rightContainer}>
                        <div style={{ display: "flex", flexGrow: "1" }}>
                            <div className={styles.productDescription}>
                                <div className={styles.productTitle}>{link.metaData.response.product_title}</div>
                                <div className={styles.productPrice}>
                                    <span>{prices ? prices?.symbol + " " + prices?.discounted_price : ""}</span>
                                    <del>{prices ? prices?.symbol + " " + prices?.actual_price : ""}</del>
                                </div>
                                <div className={styles.productCommission}></div>
                            </div>
                            <img
                                className={styles.menu}
                                src={menuIcon}
                                alt="ellipses-icon"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    setIsMenuOpened(!isMenuOpened);
                                }}
                            />
                        </div>
                        {showDivider && <div className={styles.divider}></div>}
                    </div>
                </div>
                {isMenuOpened && (
                    <ul className={styles.sectionMenu}>
                        <li className={styles.sectionMenuItem} onClick={onDelete}>
                            <img src={deleteSectionIcon} />
                            <span>Delete</span>
                        </li>
                        <li className={styles.sectionMenuItem} onClick={onShareAafLink}>
                            <img src={shareIcon} />
                            <span>Share Aff. Link</span>
                        </li>
                        <li className={styles.sectionMenuItem} onClick={onShare}>
                            <img src={shareIcon} />
                            <span>Share</span>
                        </li>
                    </ul>
                )}
            </div>
        </>
    );
};

export default index;
